import { Component, OnInit } from '@angular/core';
import { CountService } from './services/count/count.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private countService: CountService, public router: Router) {}

  get isHome(): boolean {
    return this.router.url === '/' || this.router.url === '/home';
  }

  triggerTransitionAndScroll() {
    const wrapper = document.getElementById('main-content-wrapper');
    if (wrapper) {
      wrapper.classList.remove('page-transition');
      void wrapper.offsetWidth; // trigger reflow
      wrapper.classList.add('page-transition');
    }

    // Short delay to allow for DOM rendering
    setTimeout(() => {
      const contentArea = document.getElementById('side-navigation') || document.getElementById('academics');
      if (contentArea) {
        // Scroll to the start of the side-navigation/content area with an offset
        const yOffset = -100; 
        const y = contentArea.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      } else {
        // Default to top for home and pages without side menus
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 150);
  }

  ngOnInit(): void {
    // this.countService.UpdateCount();
    this.countService.fetchCount();

    // Scroll to content on every navigation end (including sub-route transitions)
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.triggerTransitionAndScroll();
    });
  }
}

